function AboutUs() {
    return (
        <div>
            <h1>IFJB “CAPITAL” SH.P.K.</h1>
            <p> IFJB “CAPITAL” SH.P.K. Institucion Financiar Jo Bankar është themeluar në vitin 2012 në Kosovë dhe i licencuar nga Banka Qendrore e Kosovës (BQK) në kryerjen e aktivitetetit të transferit të parave,
arkëtimin e pagesave dhe këmbimin valutor.</p>
<p>IFJB “CAPITAL” SH.P.K. është kompani e specializuar në shërbime financiare, aktivitetin e saj e zhvillon në mbi 100 lokacione në mbarë Kosovën, me staf mbi 70 të punësuar, mbi 140 Agjentë të autorizuar për kryerjen e shërbimeve në emër të IFJB “CAPITAL” SH.P.K.</p>
        </div>
    )
}

export default AboutUs;